import { Injectable } from '@angular/core';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { presentationOptions, centeredPresentationOptions } from './modal-presenter.config';

@Injectable()
export class ModalPresenter extends NgbModal {
  open(content: any, options?: NgbModalOptions): NgbModalRef {
    const combinedOptions = { ...presentationOptions, ...options };
    return super.open(content, combinedOptions);
  }

  openCentered(content: any, options?: NgbModalOptions): NgbModalRef {
    const combinedOptions = { ...centeredPresentationOptions, ...options };
    return super.open(content, combinedOptions);
  }
}
